export interface ProgramResults{
    programResultsDescription: string;
}

export const defaultProgramResults: ProgramResults = {
    programResultsDescription: ""
}